import {fetchJson} from '../../Library/Fetch.js';
import {toggleLoading} from '../../Library/LoadingIndicator';

const activeRequests = new WeakMap();

const lookupUrl = (input, sku) => `${input.dataset.productPrefillUrl}?sku=${encodeURIComponent(sku)}`;

// The price and cost inputs are absent for a user without orders.pricing.
const fill = (form, name, value) => {
    const field = form.elements.namedItem(name);

    if (field === null) {
        return;
    }

    field.value = value ?? '';
};

const selectOrClear = (form, name, value) => {
    const select = form.elements.namedItem(name).closest('od-select');

    if (value) {
        select?.selectValue(value);

        return;
    }

    select?.clear();
};

const apply = (form, prefill) => {
    fill(form, 'name', prefill.name);
    fill(form, 'price', prefill.price);
    fill(form, 'cost', prefill.cost);
    fill(form, 'weight', prefill.weight);
    fill(form, 'customsCode', prefill.customsCode);
    selectOrClear(form, 'countryOfOrigin', prefill.countryOfOrigin);

    if (prefill.weightUnit !== null) {
        form.elements.namedItem('weightUnit').closest('od-select')?.selectValue(prefill.weightUnit);
    }
};

export const handleProductPrefill = async event => {
    const input = event.target;

    if (!input.matches?.('input[data-product-prefill-url]')) {
        return;
    }

    activeRequests.get(input)?.abort();

    const sku = input.value.trim();

    if (sku === '') {
        activeRequests.delete(input);
        toggleLoading(input.parentElement, false);

        return;
    }

    const controller = new AbortController();
    activeRequests.set(input, controller);
    toggleLoading(input.parentElement, true);

    const payload = await fetchJson(lookupUrl(input, sku), {signal: controller.signal});

    if (activeRequests.get(input) !== controller) {
        return;
    }

    activeRequests.delete(input);
    toggleLoading(input.parentElement, false);

    if (payload?.prefill) {
        apply(input.form, payload.prefill);
    }
};
